/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import "./Stamreeks.scss";
import React from "react";
import { GenealogySource, Parent } from "./Genealogy/types";
import { Stamreeks } from "./Stamreeks";
import { getSources } from "./Genealogy/HuygensSources";
import { getHuygensParents } from "./Stamreeksen/huygens";

export class StamreeksHuygens extends React.Component<{}, { parents: Parent[] }> {
  sources: GenealogySource[] = [];
  constructor(props: {}) {
    super(props);
    this.initialize();
  }

  initialize = () => {
    getSources().then((sources) => {
      this.sources = sources;
      this.setState({ parents: getHuygensParents(sources) });
    });
  };

  render() {
    if (!this.sources || !this.state || !this.state.parents) return <div />;

    const content = () => (
      <div>
        <h1>Stamreeks "Huygens"</h1>
        <p>
          Mijn grootmoeder was een 'Huijgens'. Volgens de overlevering zou deze Huijgens lijn ergens familie moeten zijn van Christiaan Huygens. Daarom ben ik de Huygens stamreeks
          uit gaan zoeken vanaf mijn grootmoeder, Christina Huijgens. Overigens wordt er soms 'Huygens', soms 'Huijgens' en soms zelfs "Huigens" geschreven. In het verleden namen
          ze het niet zo nauw met spelling, rond 1600 wordt in deze stamboom afwisselend Huygens en Huijgens gebruikt.
        </p>
        <p>
          Vooralsnog heb ik de link naar Christiaan Huygens niet kunnen vinden. Maar met name voor 1700 zijn de bronnen dan zeer beperkt en de informatie die ik heb kunnen vinden
          niet sluitend. Dat ik het niet heb kunnen vinden betekent dus niet dat die er niet is.
        </p>
      </div>
    );

    return <Stamreeks content={content()} sources={this.sources} parents={this.state.parents} />;
  }
}
